var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightroom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2438,
    viewBox: "0 130.746 595.279 580.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.803 155.549h545.674v530.792H24.803V155.549z",
    fill: "#05151f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.803 155.549h545.674v530.792H24.803V155.549zM0 711.145h595.28V130.746H0v580.399zm348.487-336.086c0-2.977 0-10.169-1.24-24.06 0-1.984.496-2.48 1.984-3.224 15.13-6.201 51.095-17.114 91.276-17.114 1.984 0 2.977.496 2.977 2.48v35.717c0 1.984-.744 2.48-2.977 2.48-15.626-.744-38.693 1.24-47.374 4.96v156.51c0 1.984-.744 2.976-2.977 2.976h-38.941c-1.984 0-2.977-.744-2.977-2.976v-157.75h.249v.001zM164.943 535.784c-2.977 0-3.721-1.239-3.721-3.72V265.428c0-1.984.744-3.225 2.977-3.225h39.188c1.984 0 2.48.744 2.48 2.977v229.679h102.189c1.984 0 2.729.744 2.232 2.977l-6.2 35.221c-.496 1.983-1.736 2.976-3.721 2.976H164.943v-.249z",
    fill: "#aad1eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightroom);
export default __webpack_public_path__ + "static/media/lightroom.7ab18c691d454f81dca748566b7ea8a7.svg";
export { ForwardRef as ReactComponent };